import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Card } from 'primereact/card';
import { useTranslation } from 'react-i18next';
import AllNotificationsList from '@components/obsolete/AllNotificationsList/AllNotificationsList.tsx';
import NotificationCenterList from '@app/pages/notifications/NotificationCenterList.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import LegacyVersionSwitch from '@components/framework/LegacyVersionSwitch.tsx';
import { BetaSurface } from '@hooks/useBetaVersion/betaSurfaces.ts';

const NotificationListPage = () => {
  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout title={t(`notifications.notifications`, `Notifications`)}>
      <LegacyVersionSwitch surface={BetaSurface.NOTIFICATION_CENTER}>
        {showLegacy =>
          showLegacy ? (
            // @ts-ignore
            <Card>
              <AllNotificationsList />
            </Card>
          ) : (
            <NotificationCenterList />
          )
        }
      </LegacyVersionSwitch>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(NotificationListPage);